<template>
    <article class="team-member pt-5 pb-5 bg-bottom">
        <div class="container">
            <div class="media">
                <figure>
                    <img src="../assets/team-members/big/liz.png" alt="">
                </figure>
                <div class="media-body">
                    <h5 class="mt-0">Liz Mann</h5>
                    <h6 class="mb-5">CFO at <span>Empower Direct</span></h6>
                    <p>
                        An accounting and finance expert for nearly 20 years, Liz handles all financial reporting, accounting, client relations and project coordination at Empower Direct.  Her innate attention to detail and passion for helping small business grow and thrive began with her first post-collegiate job as a bookkeeper for a small firm. Since then Liz has helped numerous businesses improve their budget management and get the marketing results they require to succeed.
                    </p>

                    <p>
                        Contact Liz to discuss how she and the Empower Direct team can help your business: <a href="mailto:liz@empowerdirect.io">liz@empowerdirect.io</a>
                    </p>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
    export default {
        name: 'LizMann',
    };
</script>

<style scoped>

</style>
